import { useMemo } from "react";
import { subDays } from "date-fns";
import { formatDateForAPI } from "utils/utils";

import {
  COLUMNS,
  DEFAULT_FILTERS,
  FIELDS,
  TITLE,
} from "@/modules/timesheet/logs/views/table/constants";

import List from "components/list";
import { TIMESHEET_LOG_DAY_VIEW } from "@/lib/utils";
import TimeSheetLogLayout from "@/modules/timesheet/logs/layout";
import TimesheetFilters from "./filters";
import { TimesheetHeaderTitle } from "@/modules/timesheet/components/header";

export default function TimesheetLogsTable() {
  const defaultFilters = useMemo(() => {
    const today = new Date();
    return {
      ...DEFAULT_FILTERS,
      date: {
        _gte: formatDateForAPI(subDays(today, 6)),
        _lte: formatDateForAPI(today),
      },
    };
  }, []);

  return (
    <TimeSheetLogLayout
      headerContent={<TimesheetHeaderTitle>{TITLE}</TimesheetHeaderTitle>}
    >
      <List
        title=""
        storageKey="timesheet-log"
        filters={defaultFilters}
        endPoint="timesheet"
        showSearch={false}
        columns={COLUMNS}
        sortBy="date_created"
        sortOrder="desc"
        teleportFilterButton={true}
        meta={{
          fields: FIELDS,
        }}
        renderFilters={TimesheetFilters}
        href={(item) => `/${TIMESHEET_LOG_DAY_VIEW}/${item.id}`}
      />
    </TimeSheetLogLayout>
  );
}
